import React from 'react';
import { usePrerequisites } from "../contexts/Prerequisites";
import EndoSetupPhysicianTable from '../AppGrid/EndoSetupPhysicianTable';
import CommonBreadCurmb from '../components/common/CommonBreadCrumb';
import connectionService from '../services/Connection';
import consts from '../consts';
import catAdminUtil from '../util/catAdminUtils';

const EndoSetupPhysician = () => {
	const [{ strings }] = usePrerequisites();
	return <CommonBreadCurmb
		docTitle={strings.EndoSetupPhysician}
		breadcrumbs={[{ text: strings.EndoSetupPhysician }]}
		Component={EndoSetupPhysicianTable}
		handleSubmit={catAdminUtil.handleOnSubmit}
		maxCount={consts.maxUserCount}
		message={strings.UserCountWarning}
		apiUrl={connectionService.EndoSetupPhysician}
		navigateUrl={"/endoSetupPhysician"}
	/>
}

export default EndoSetupPhysician;